import gql from "graphql-tag";

export const createMasterContent = gql`
  mutation CreateContentGroup($data: MasterContentCreateInput!) {
    createMasterContent(data: $data) {
      id
    }
  }
`;
